export default __webpack_public_path__ + "static/media/add.684d7bf6.svg";